<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Measurement Quantity Technical Manager '{{inner_quantity_Record.title}}'</h5>

      <img *ngIf="Procssing_Personel" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!Procssing_Personel" type="button" (click)="openModal_Personeln(templatePersonel)" class="btn btn-info"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Technical Manager </button>


      <br/>
      <br/>

      <div class="table-responsive" >
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>National ID</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Person_Quantity">
             <td>{{DataList_Person_Quantity.indexOf(item)+1}}</td>
              <td>{{item.fname}}</td>
              <td>{{item.lname}}</td>
              <td>{{item.codeMeli}}</td>
              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div  class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-remove"></i> Delete </a>
                      </div>
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
  </div>
</div>


<ng-template #template>
  <div class="modal-header">
     <h4 class="modal-title pull-left">Confirm Technical Manager Deletion '{{Data_Seleted_Delete.fname}} {{Data_Seleted_Delete.lname}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="Delete()"> Delete <i class="fa fa-remove"></i></button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templatePersonel>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Personnel List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Personel.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Last Name</label>
          <input [(ngModel)]="Filter_Familly" (keyup)="Change_Filter()" name="Filter_Familly" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Full Name</th>
              <th>National ID</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Personel_List
            |filter:Filter_Familly:'fullname'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: Personelpage,
                        totalItems: (Personel_List
                        |filter:Filter_Familly:'fullname'
                        ).length
                      }
            ">
              <td>{{Personel_List.indexOf(item)+1}}</td>
              <td>{{item.fullname}}</td>
              <td>{{item.codemeli}}</td>
              <td (click)="Set_Selected_Personel_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_Personel" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_Personel" type="button" (click)="Read_Personel()"
      class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Personel.hide()">Close</button>
  </div>
</ng-template>
